import React from 'react';
import { GlobalProvider } from './global';
import { AuthProvider } from './auth';
import { ThemeProvider } from './theme';

export const Hooks: React.FC = ({ children }) => {
  return (
    <GlobalProvider>
      <AuthProvider>
        <ThemeProvider>{children}</ThemeProvider>
      </AuthProvider>
    </GlobalProvider>
  );
};
